import { defineMessages } from 'react-intl';

export default defineMessages({
    breedMessage: {
        id: 'tfpa.policyChange.views.messages.breedMessage',
        defaultMessage: 'This is a required field.'
    },
});